import React, { Component } from "react";
import { connect } from "react-redux";
//import { getGroups } from "../actions/groupActions";
import GroupCard from "../components/GroupCard";
import FeaturedProducts from "../containers/FeaturedProducts";
import { withTranslation } from 'react-i18next';


class ProductGroupsList extends Component {
  render() {
      const { t, groups, settings } = this.props;


      if (!groups || !groups.items || groups.items.length === 0) return <div />;

    
      const groupsList = groups.items.map(group => (
          <GroupCard key={group.id} group={group} smCols={6} mdCols={4} baseUrl={settings.baseUrl} />
      ));

      if (settings.isCatalogueMode === true) {
          return (<div className="row"> {groupsList}</div>);
      }


    const ads = this.props.showAds ? (
      <div
        className="alert alert-image-bg alert-dismissible fade show text-center mb-4"
        style={{ backgroundImage: "url(img/banners/alert-bg.jpg)" }} >
        <span className="alert-close text-white" data-dismiss="alert" />
        <div className="h3 text-medium text-white padding-top-1x padding-bottom-1x">
                <i className="icon-clock ad-icon" />&nbsp;&nbsp;{t("Check our Limited Offers. (Our Ads goes here )")}&nbsp;&nbsp;&nbsp;
          <div className="mt-3 hidden-xl-up" />
                <a href={null} role="button" className="btn btn-primary">{t("View Offers")}</a>
        </div>
      </div>
      ) : "";

  

    return (
      <div className="row">
        {/* <!-- Sidebar          --> */}
        <FeaturedProducts isHorizontal={false} numberOfProducts="10" />
        {/* <!-- Categories--> */}
        <div className="col">
          {/* <!-- Promo banner--> */}
          {ads}
                <div className="row">{groupsList}</div>
               
        </div>
      </div>
    );
  }
}

function mapStateToProps({ groups, settings, activePage }) {
    return {  groups, settings, activePage };
}

export default withTranslation()(connect(mapStateToProps,null)(ProductGroupsList));
